var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Radio',{attrs:{"name":_vm.name,"value":_vm.value},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var isChecked = ref.isChecked;
return [_c('div',{staticClass:"btn",class:{
        'btn--selected': isChecked,
      },on:{"click":_vm.uncheckIfSelected}},[_vm._t("default",null,{"isChecked":isChecked})],2)]}}],null,true),model:{value:(_vm._checked),callback:function ($$v) {_vm._checked=$$v},expression:"_checked"}})}
var staticRenderFns = []

export { render, staticRenderFns }